import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import { styled } from '@mui/material/styles'
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';

const CitStepConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
      [theme.breakpoints.up('xs')]: {
        top: 12,
      },
      [theme.breakpoints.up('sm')]: {
        top: 22,
      }
    },

    [`&.${stepConnectorClasses.active}`]: {
      [`& .${stepConnectorClasses.line}`]: {
          borderTop:'2px dotted #98A2B3'
      },
    },
    [`&.${stepConnectorClasses.completed}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        height: 2,
        backgroundColor:'#1E87FF'
      },
    },
    [`& .${stepConnectorClasses.line}`]: {
      height: 0,
      border: 0,
      backgroundColor:
        theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
      borderRadius: 1,
    },
  }));

  const CitStepIconRoot = styled('div')(({ theme, ownerState }) => ({
    backgroundColor: '#FFF',
    zIndex: 1,
    color: '#fff',
    width: 25,
    height:25,
    display: 'flex',
    border: '1px solid  #98A2B3',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    ...(ownerState.active && {
        border: '1px solid  #1E87FF',
    }),
    ...(ownerState.completed && {
       background:'#1E87FF',
       border:'none'
    }),
    [theme.breakpoints.up('sm')]: {
      width: 50,
      height:50,
    },
  }))


  function CitStepIcon(props) {
    const { active, completed, className } = props;
  
    return (
      <CitStepIconRoot ownerState={{ completed, active }} className={className}>
        <Typography color= {active ? '#1E87FF': completed ? '#FFF':'#98A2B3'} fontSize={'16px'} fontFamily={'Inter'} fontStyle={'normal'} fontWeight={700} lineHeight={'24px'} >{props.icon}</Typography>
      </CitStepIconRoot>
    );
  }

  CitStepIcon.propTypes = {
    /**
     * Whether this step is active.
     * @default false
     */
    active: PropTypes.bool,
    className: PropTypes.string,
    /**
     * Mark the step as completed. Is passed to child components.
     * @default false
     */
    completed: PropTypes.bool,
    /**
     * The label displayed in the step icon.
     */
    icon: PropTypes.node,
  };
  

  export {CitStepConnector,CitStepIcon}